import type { SelectFieldOption } from '@hrlogics/react-helper-types';

import type { Nullable } from '@clearverify/types';

import type { AddressFieldsFormFields } from 'src/constants/address';

export const PeoPayrollProviderCompanyInformationFormFields = {
  displayName: 'displayName',
  industry: 'industry',
  corporateStructure: 'corporateStructure',
  numberOfEmployees: 'numberOfEmployees',
  contactEmail: 'contactEmail',
  contactPhoneNumber: 'contactPhoneNumber',
  taxYearEndDate: 'taxYearEndDate',
  headquarters: 'headquarters',
  defaultDisclaimer: 'defaultDisclaimer',
  fein: 'fein',
} as const;

export type PeoPayrollProviderCompanyInformationFormValues = {
  [PeoPayrollProviderCompanyInformationFormFields.displayName]: string;
  [PeoPayrollProviderCompanyInformationFormFields.fein]: string;
  [PeoPayrollProviderCompanyInformationFormFields.industry]?: Nullable<SelectFieldOption>;
  [PeoPayrollProviderCompanyInformationFormFields.taxYearEndDate]?: Nullable<string>;
  [PeoPayrollProviderCompanyInformationFormFields.corporateStructure]?: Nullable<string>;
  [PeoPayrollProviderCompanyInformationFormFields.numberOfEmployees]?: Nullable<number>;
  [PeoPayrollProviderCompanyInformationFormFields.contactEmail]: string;
  [PeoPayrollProviderCompanyInformationFormFields.contactPhoneNumber]?: Nullable<string>;
  [PeoPayrollProviderCompanyInformationFormFields.defaultDisclaimer]?: Nullable<string>;
  [PeoPayrollProviderCompanyInformationFormFields.headquarters]: Nullable<{
    [AddressFieldsFormFields.street]: string;
    [AddressFieldsFormFields.city]: string;
    [AddressFieldsFormFields.county]?: Nullable<string>;
    [AddressFieldsFormFields.state]: string;
    [AddressFieldsFormFields.zipCode]: string;
  }>;
};
